/**
 * main.js
 * @desc loads all dependencies dynamically via querySelectors
 */
import Capitan from '../js/Capitan/Capitan'; // Necessary for storybook to show components

const storybook = document.querySelector('.storybook'); // Sync DOM setup

if (document.querySelector('.stage')) {
  document.querySelector('body').classList.add('has-stage');
}

if (document.querySelector('[class^="stage"]') && document.querySelector('.breadcrumb')) {
  document.querySelector('body').classList.add('has-stage');
} // Top-level await: load components in parallel, no IIFE/wrapper (Sonar S7785)


const componentLoads = [import(
/* webpackPrefetch: true */
'lazysizes'), import(
/* webpackChunkName: "navigation" */
'../../components/navigation/main').then(m => {
  m.init();
}), (Capitan.Vars.doc.querySelector('.scrolltop') || storybook) && import(
/* webpackChunkName: "scrolltop" */
'../../components/scrolltop/scrolltop').then(m => {
  m.init();
}), document.querySelector('[class^="stage"]') && document.querySelector('.breadcrumb') && import(
/* webpackChunkName: "stage" */
'../../components/stage/stage').then(m => {
  m.init();
}), (document.querySelector('.header') || storybook) && import(
/* webpackChunkName: "header" */
'../../components/header/header').then(m => {
  m.init();
}), (document.querySelector('.form') || storybook) && import(
/* webpackChunkName: "form-validation" */
'../../components/form/form-validation').then(m => {
  m.init();
}), (document.querySelector('.has-iframe') || storybook) && import(
/* webpackChunkName: "form-validation" */
'../../components/embed-iframe/embed-iframe').then(m => {
  m.init();
}), (document.querySelector('.form') || storybook) && import(
/* webpackChunkName: "form" */
'../../components/form/form').then(m => {
  m.init();
}), (document.querySelector('.tile__content--collapsable') || storybook) && import(
/* webpackChunkName: "tile__content--collapsable" */
'../../components/tile/tile').then(m => {
  m.init();
}), (document.querySelector('.reveal') || storybook) && import(
/* webpackChunkName: "reveal" */
'../../components/reveal/reveal').then(m => {
  m.init();
}), (Capitan.Vars.doc.querySelector('.tooltip') || storybook) && import(
/* webpackChunkName: "tooltip" */
'../../components/tooltip/tooltip').then(m => {
  m.init();
}), (document.querySelector('.notification') || storybook) && import(
/* webpackChunkName: "notification" */
'../../components/notification/notification').then(m => {
  m.init();
}), (document.querySelector('.modal') || storybook) && import(
/* webpackChunkName: "modal" */
'../../components/modal/modal').then(m => {
  m.init();
}), (document.querySelector('.custom-select') || storybook) && import(
/* webpackChunkName: "custom-select" */
'../../components/custom-select/custom-select').then(m => {
  m.init();
}), (document.querySelector('.customer-bar--autoplay') || storybook) && import(
/* webpackChunkName: "customer-bar-autoplay" */
'../../components/customer-bar/customer-bar-autoplay').then(m => {
  m.init();
}), (document.querySelector('.customer-module') || storybook) && import(
/* webpackChunkName: "customer-module" */
'../../components/customer-module/customer-module').then(m => {
  m.init();
}), (Capitan.Vars.doc.querySelector('.swiper') || storybook) && import(
/* webpackChunkName: "swiper" */
'../../components/swiper/swiper').then(m => {
  m.init();
}), (Capitan.Vars.doc.querySelector('.swiper-wrapper') || storybook) && import(
/* webpackChunkName: "swiper" */
'../../components/image/image').then(m => {
  m.init();
}), (Capitan.Vars.doc.querySelector('.swiper-thumbs') || storybook) && import(
/* webpackChunkName: "swiper-thumbs" */
'../../components/swiper/swiper-thumbs').then(m => {
  m.init();
}), (document.querySelector('.embed-video') || storybook) && import(
/* webpackChunkName: "embed-video" */
'../../components/embed-video/embed-video').then(m => {
  m.init();
}), (document.querySelector('.blog-reveal') || storybook) && import(
/* webpackChunkName: "blog-reveal" */
'../../components/blog/blog-reveal').then(m => {
  m.init();
}), (document.querySelector('.spotify-container') || storybook) && import(
/* webpackChunkName: "spotify-embed" */
'../../components/spotify-embed/spotify-embed').then(m => {
  m.init();
}), (document.querySelector('.animation') || storybook) && import(
/* webpackChunkName: "animation" */
'../../components/animation/animation').then(m => {
  m.init();
}), (document.querySelector('.dialog') || storybook) && import(
/* webpackChunkName: "dialog" */
'../../components/dialog/dialog').then(m => {
  m.init();
}), (document.querySelector('.image-lightbox') || storybook) && import(
/* webpackChunkName: "image-lightbox" */
'../../components/image-lightbox/image-lightbox').then(m => {
  m.init();
})].filter(Boolean); // Fire all component loads in parallel; no top-level await (Webpack 4 / current Babel don't support it).

Promise.all(componentLoads);
/** Kept for Storybook/compatibility: init is called after import; setup runs via Promise.all above. */

export default function init() {}